import React from 'react'
import Modal from '../components/modal/modal.component'
import ModalHeader from '../components/modal/modal-header.component'
import ModalBody from '../components/modal/modal-body.component'
import ModalFooter from '../components/modal/modal-footer.component'
import { IconTrash } from '@tabler/icons-react'
import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { deleteCity } from '../fetch/weather.fetch'
import { useNavigate } from 'react-router-dom'

const RemoveCityModal = ({data, setRemoveCityModal}) => {
	const token = useSelector( state => state.user.token );
	const navigate = useNavigate();

	// ----------------------------------------------------------
	// ReactQuery Muttion (POST)
	// ----------------------------------------------------------
	const mutation = useMutation({ 
        // detecting if editing or creating new service
		mutationFn: () => deleteCity(token, data.id),
		onSuccess: (res) => {
            setRemoveCityModal(false)
			navigate('/weather')
		},
	})

	return (
		<Modal>
			<div className="modal-content">
				<ModalHeader title="Suspend User?" />
				
				<ModalBody>
					<p>Дали сте сигурни дека сакате да го избришете {data?.name}?</p>
				</ModalBody>
				
				<ModalFooter>
					<button type="button" onClick={() => setRemoveCityModal(false)} className="btn btn-outline-info border-0">Не</button>
					<button type="button" className="btn btn-danger" onClick={mutation.mutate}>
						<IconTrash size={18} className="me-1" />
						Избриши
					</button>
				</ModalFooter>
			</div>

			<div className="modal-backdrop" onClick={ () => setRemoveCityModal(false) }></div>
		</Modal>
	)
}

export default RemoveCityModal